export enum AuthGroupTypesEnum {
  Admin = 1,
  Curator,
  Dispatcher,
  ServiceEngineer,
  DispatcherGRS,
  ServiceEngineerGRS,
}
